import { useState } from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import Swiper from "react-id-swiper";
import { faq } from "../../lib/faq";
import FAQItem from "./FAQItem";
import { FaPlus } from "react-icons/fa";
import { useEffect } from "react";
import Schemas from "../../layouts/schema.json";
import { useRouter } from "next/router";


const Faq = ({ showFull = false }) => {
  const [show, setShow] = useState(false);
  const router = useRouter();
  const isService = router.pathname == "/services/[...slug]";
  const [faqsList, setFaqList] = useState([]);

  useEffect(() => {
    const CurrentPage = (router?.query && router?.query?.slug?.length) ? router?.query?.slug[1] : "";
    const Data = Schemas;
    Data.FAQ?.map((item) => {
      if (item.page == CurrentPage) {
        setFaqList(item.Question)
      }
    });
  }, [router]);

  return (
    <div
      className="category-slider-area space-pb--r50"
      id="faq"
      data-aos="fade-up"
      data-aos-delay="700"
    >
      <Container>
        <h2 className="mb-4 text-center faq-color-all">Frequently Asked Questions </h2>
        <Row>
          <Col
            xs={12}
            className="d-flex justify-content-center align-items-center"
          >
            {faqsList && faqsList.length ?
              <div className="faq-model">
                {faqsList.map((item, index) => (
                  <>
                    {showFull ? (
                      <FAQItem data={item} show={show} setShow={setShow} />
                    ) : (
                      <>
                        {index < 6 && (
                          <FAQItem data={item} show={show} setShow={setShow} />
                        )}
                      </>
                    )}
                  </>
                ))}
                {!showFull && (
                  <Link href="/faq">
                    <a className="w-100">
                      <p className="text-center text-white">
                        View More <FaPlus />
                      </p>
                    </a>
                  </Link>
                )}
              </div>
              : <div className="faq-model">
                {faq.map((item, index) => (
                  <>
                    {showFull ? (
                      <FAQItem data={item} show={show} setShow={setShow} />
                    ) : (
                      <>
                        {index < 6 && (
                          <FAQItem data={item} show={show} setShow={setShow} />
                        )}
                      </>
                    )}
                  </>
                ))}
                {!showFull && (
                  <Link href="/faq">
                    <a className="w-100">
                      <p className="text-center text-white">
                        View More <FaPlus />
                      </p>
                    </a>
                  </Link>
                )}
              </div>}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Faq;
